import { jsx as s } from "@emotion/react/jsx-runtime";
import r, { dividerClasses as e } from "@mui/material/Divider";
const t = e, d = ({ ...i }) => /* @__PURE__ */ s(r, { ...i });
d.displayName = "Divider";
export {
  d as D,
  t as d
};
